import style from '../../common-style/common-style.module.css';

const BmpBsci = ({bsci}) => {
    if (!bsci) {
        return '-';
    }
    let bsciStatus = '';
    const bsciNum = parseFloat(bsci);
    if (bsciNum >= 0.75) {
        bsciStatus = `bsciScoreGreen`;
    } else if (bsciNum >= 0.60 && bsci <= 0.74) {
        bsciStatus = `bsciScoreAmber`;
    } else if (bsciNum < 0.60) {
        bsciStatus = `bsciScoreRed`;
    }
    return (
        <>
            <span className={`${style.bsciScore} ${style[bsciStatus]}`}></span>
            {bsciNum}
        </>
    )
};

export default BmpBsci;